export default "__VITE_ASSET__Dsj$o4c0__"